import { api } from "./client";
import type {
  InterviewWordingChange,
  InterviewWordingEditor,
  InterviewWordingPreview,
} from "@/types/interviewWording";

// Admin "Interview Wording" transport: read the interview's wording overlaid
// with the override store, draft, preview, publish, revert to default, and read
// one item's change log. (No React Query here — that lives in
// hooks/interviewWording.)
//
// Block keys carry dots (`q.EXP1.opt.yes_before`), so they ride the body or the
// query string, never a URL segment.
export const interviewWordingApi = {
  get: () => api.get<InterviewWordingEditor>("/admin/interview-wording"),

  saveDraft: (blockKey: string, text: string | null) =>
    api.put<InterviewWordingEditor>("/admin/interview-wording/drafts", { blockKey, text }),

  discardDraft: (blockKey: string) =>
    api.post<InterviewWordingEditor>("/admin/interview-wording/drafts/discard", { blockKey }),

  publish: (note: string | null) =>
    api.post<InterviewWordingEditor>("/admin/interview-wording/publish", { note }),

  revert: (blockKey: string) =>
    api.post<InterviewWordingEditor>("/admin/interview-wording/revert", { blockKey }),

  preview: (blockKey: string, text: string) =>
    api.post<InterviewWordingPreview>("/admin/interview-wording/preview", { blockKey, text }),

  history: (blockKey: string) =>
    api.get<InterviewWordingChange[]>("/admin/interview-wording/history", { blockKey }),
};
